<template>
    <div v-title="'签到有礼 - 欢乐斗地主'"
         class="sign-in">
        <div class="wrap">
            <a @click="toSignin"
               class="btn"
               href="javascript:void(0)"></a>

            <div class="user-wrap">
                <div v-if="isBind"
                     class="is-Sign">你好,<span class="user-name">{{characName}}</span>&nbsp;<a @click="rebind"
                       class="sign-btn"
                       href="javascript:void (0)">更改</a></div>
                <div v-else
                     @click="getRole"
                     class="no-Sign"><a class="sign-btn"
                       href="javascript:void (0)">请绑定</a>
                </div>
            </div>

        </div>

        <div v-if="showReward"
             class="dialog-reward">
            <div class="dialog-reward-content">
                <div class="brand-box">
                    <img :src="cardImg"
                         alt="扑克牌"
                         class="img-card">
                </div>
                <img class="reward"
                     :src="rwImg"
                     alt="奖品图">
                <a @click="showReward = false"
                   class="reward-close"
                   href="javascript:void(0)"></a>
                <a @click="showReward = false"
                   class="reward-sure-btn"
                   href="https://age.qq.com/weixin/html/huanle_download.html"></a>
            </div>
        </div>

        <div class="total">
            <p>我的累计幸运值：{{luckyNum}}</p>
        </div>

        <div class="dia-card-luck" v-if="showCard">
            <div class="card-lucky">
                <div class="brand-box">
                    <img :src="cardImg"
                         alt="扑克牌"
                         class="img-card">
                </div>
                <a @click="showCard = false" href="javascript:;" class="card-close"></a>
                <a @click="showCard = false" href="https://age.qq.com/weixin/html/huanle_download.html" class="card-sure-btn"></a>
            </div>
        </div>
        
    </div>
</template>

<script>
import wxMethods from '@/utils/wxMethods'
import mtaInitial from '@/utils/mtaInitial'
import Http from '@/utils/Http'
import './mobile_rem'

export default {
    name: 'SignIn',

    mixins: [wxMethods],
    data() {
        return {
            isBind: false,
            characName: '',
            signDays: 0,
            showReward: false,
            showCard: false,
            hasSignin: false,
            getRwFail: false,
            rwImg: '',
            cardImg: '',
            gameTool: null
        }
    },
    computed: {
        // 累计幸运值
        luckyNum() {
            let signDays = parseInt(this.signDays, 10)

            if (signDays === 0) {
                return 0
            } else if (signDays % 10 === 0) {
                return 100
            }
            return (signDays % 10) * 10
        },
    },
    created() {
        this.signInId = this.$route.query.id
        this.wxHideMenu()
        this.initRole()
        this.getRole()
    },

    mounted() {
        mtaInitial(process.env.VUE_APP_MTA_SIGNIN_SID, process.env.VUE_APP_MTA_SIGNIN_CID)
        this.changeCardImg()
    },

    methods: {
        initRole() {
				this.gameTool = new GameTools({
					// site: `txy_${GAME}`,
					game: 'hlddz',
					allowPlatForm: ['wx'],
					loginType: 'wx',
				})
		},
        popCard(){
            this.showCardLucky = true
        },
        getRole() {
            if (this.binding) return
            this.binding = true
            this.gameTool.getRole(process.env.VUE_APP_GAME).then(res => {
                this.binding = false
                if (res.hasRole) {
                    this.isBind = true
                    this.characName = res.roleInfo.charac_name
                    this.checkSign()
                } else {
                    res.serverSelect.STD_SYSTEM_DATA.length = 2
                    const modal = new GameModal({
                        gameTool: this.gameTool,
                        game: process.env.VUE_APP_GAME,
                        serverSelect: res.serverSelect,
                        confirmText: ' ',
                        showClose: true,
                    })

                    modal.show()

                    modal.afterBind = (isBinded, characName) => {
                        if (isBinded) {
                            this.isBind = true
                            this.characName = characName
                            modal.hide()
                            alert('绑定成功')
                        } else {
                            alert('未查询到角色')
                        }
                    }
                    modal.afterUnBind = (isUnBinded) => {
                        if (isUnBinded) {
                            modal.hide()
                            this.isBind = false
                            this.characName = ''
                            alert('解绑成功')
                        }else{
                            alert('解绑失败，请重试')
                        }
                    }
                }
            })
        },

        rebind() {
            if (this.loading || this.binding) return
            this.binding = true
            this.gameTool.getServerSelect(process.env.VUE_APP_GAME).then(serverSelect => {
                serverSelect.STD_SYSTEM_DATA.length = 2
                this.binding = false
                const modal = new GameModal({
                    gameTool: this.gameTool,
                    game: process.env.VUE_APP_GAME,
                    serverSelect,
                    confirmText: ' ',
                    showClose: true,
                })
                modal.show()
                modal.afterBind = (isBinded, characName) => {
                    if (isBinded) {
                        this.isBind = true
                        this.characName = characName
                        modal.hide()
                        alert('绑定成功')
                    } else {
                        alert('未查询到角色')
                    }
                }
                modal.afterUnBind = (isUnBinded) => {
                    if (isUnBinded) {
                        modal.hide()
                        this.isBind = false
                        this.characName = ''
                        alert('解绑成功')
                    }else{
                        alert('解绑失败，请重试')
                    }
                }
            })
        },

        // 查询签到
        checkSign() {
            this.loading = true
            Http.get({
                path: 'awp-signin/check',
                params: {
                    id: this.signInId,
                },
            })
                .then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        if (res.result.today_signin === 1) {
                            const rwStatus = res.result.lottery.status
                            if (rwStatus === 1 || rwStatus === 3) {
                                this.signDays = res.result.signin_count
                                this.hasSignin = true
                            } else {
                                if (rwStatus === 0) return
                                this.signDays = res.result.signin_count - 1
                                this.signDays = 5
                                // 领取奖励失败
                                this.getRwFail = true
                            }
                        } else {
                            this.signDays = res.result.signin_count
                        }
                    } else {
                        alert(res.msg)
                    }
                })
                .catch(err => {
                    console.warn('error', err)
                    this.loading = false
                    alert(err.msg)
                })
        },

        // 签到接口
        signin() {
            this.loading = true
            let that = this
            Http.post({
                path: 'awp-signin/register',
                params: {
                    id: this.signInId,
                },
            })
                .then(res => {
                    if (res.code === 0) {
                        const rwStatus = res.result.lottery.status
                        if (rwStatus === 1) {
                            this.signDays = res.result.signin_count
                            this.rwImg = res.result.reward_info.reward_image
                            this.hasSignin = true
                            setTimeout(function() {
                                that.showReward = true

                                that.loading = false
                            }, 300)
                        } else if (rwStatus === 2) {
                            this.loading = false
                            this.getRwFail = true
                            alert('发奖失败，请再次点击领取')
                        } else if (rwStatus === 3) {
                            alert(res.result.lottery.hint_no_reward)
                            this.hasSignin = true

                            this.loading = false
                        } else {
                            alert(res.msg)

                            this.loading = false
                        }
                    } else {
                        alert(res.msg)

                        this.loading = false
                    }
                })
                .catch(err => {
                    console.warn('error', err)
                    this.loading = false
                    alert(err.msg)
                })
        },

        // 重新领取奖励
        retryLottery() {
            this.loading = true
            let that = this

            Http.post({
                path: 'awp-signin/retryLottery',
                params: {
                    id: this.signInId,
                },
            })
                .then(res => {
                    if (res.code === 0) {
                        const rwStatus = res.result.status
                        if (rwStatus === 1) {
                            this.signDays += 1
                            this.rwImg = res.result.reward_info.reward_image
                            setTimeout(function() {
                                that.showReward = true
                                that.loading = false
                            }, 300)
                            this.getRwFail = false
                        } else if (rwStatus === 2) {
                            alert('发奖失败，请再次点击领取')
                            this.loading = false
                        } else {
                            alert(res.msg)
                            this.loading = false
                        }
                    } else {
                        alert(res.msg)
                        this.loading = false
                    }
                })
                .catch(err => {
                    console.warn('error', err)
                    this.loading = false
                    alert(err.msg)
                })
        },

        // 签到
        toSignin() {
            if (this.loading || this.binding) return
            if (!this.isBind) {
                this.getRole()
                return
            }
            if (this.hasSignin) {
                // alert('今天已经签到过了，请明天再来吧~')
                this.showCard = true
            } else if (this.getRwFail) {
                this.retryLottery()
            } else {
                this.signin()
            }
        },
        //扑克牌每日更新,(存cookie)
        setCookie() {
            // img23
            //在1-54中产生一个随机索引,设置cookie每日0点过期
            var imgIndex = Math.floor(Math.random() * (54 - 1) + 1)
            var cardImgSrc = require('@/assets/signin/card/card' + imgIndex + '.png')
            var cookieName = 'cardImg'
            //当前日期
            var curDate = new Date()
            //当前时间戳
            var curTamp = curDate.getTime()
            //当日凌晨的时间戳,减去一毫秒是为了防止后续得到的时间不会达到00:00:00的状态
            var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1
            //当日已经过去的时间（毫秒）
            var passedTamp = curTamp - curWeeHours
            //当日剩余时间
            var leftTamp = 24 * 60 * 60 * 1000 - passedTamp
            var leftTime = new Date()
            leftTime.setTime(leftTamp + curTamp)
            //创建cookie
            document.cookie =
                cookieName + '=' + escape(cardImgSrc + '') + ';expires=' + leftTime.toGMTString()
        },
        getCookie(name) {
            var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
            if (arr != null) {
                return unescape(arr[2])
            } else {
                return null
            }
        },
        changeCardImg() {
            var cookieName = 'cardImg'
            if (this.getCookie(cookieName)) {
                this.cardImg = this.getCookie(cookieName)
            } else {
                this.setCookie()
                this.cardImg = this.getCookie(cookieName)
            }
        },
    },
}
</script>

<style src="./SignIn.scss" lang="scss"></style>